import axios from "axios";
import { GAC_UPLOAD_DIRS } from "../constants/gacSite";

const UPLOAD_URL =
  "https://53fde1b606cff91e7a3b23ff9c242152.grupoalianzacolombia.com/upload.php";

const ALLOWED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"];

const uploadBannerImageGac = async (file) => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error("Formato no permitido. Usa JPG, PNG, GIF o WEBP.");
  }

  const formData = new FormData();
  formData.append("fileToUpload", file);
  formData.append("uploadDir", GAC_UPLOAD_DIRS.banners);

  const response = await axios.post(UPLOAD_URL, formData);
  const url = response.data?.data?.fileUrl;

  if (!url) {
    throw new Error(
      response.data?.message || "El servidor no devolvió la URL de la imagen",
    );
  }

  if (!String(url).includes(GAC_UPLOAD_DIRS.banners)) {
    throw new Error(
      `La imagen no se guardó en la carpeta GAC (${GAC_UPLOAD_DIRS.banners}).`,
    );
  }

  return url;
};

export { uploadBannerImageGac, GAC_UPLOAD_DIRS };
